var React = require('react');

function DoubleChevronDown (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M1.32004 1.66575C0.984575 1.37822 0.479536 1.41707 0.191999 1.75253C-0.0955388 2.08799 -0.0566895 2.59303 0.278771 2.88056L11.9994 12.9268L23.72 2.88056C24.0555 2.59303 24.0943 2.08799 23.8068 1.75253C23.5192 1.41707 23.0142 1.37822 22.6787 1.66575L11.9994 10.8195L1.32004 1.66575Z","key":0}),React.createElement("path",{"d":"M1.32004 11.2657C0.984575 10.9782 0.479536 11.0171 0.191999 11.3525C-0.0955388 11.688 -0.0566895 12.193 0.278771 12.4806L11.9994 22.5268L23.72 12.4806C24.0555 12.193 24.0943 11.688 23.8068 11.3525C23.5192 11.0171 23.0142 10.9782 22.6787 11.2657L11.9994 20.4195L1.32004 11.2657Z","key":1})]));
}

DoubleChevronDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"white"};

module.exports = DoubleChevronDown;

DoubleChevronDown.default = DoubleChevronDown;
